module.exports = __webpack_public_path__ + "static/media/symbolLogo.dec07fd5.svg";